<template>
  <div @click="onAddSpark" 
       class="rounded-lg border p-6 pt-8 bg-orange-100 text-orange-800 border-orange-300 hover:border-orange-600 aspect-square cursor-pointer flex flex-col flex-1 justify-start items-center gap-4">
    <div class="w-10 h-10 flex items-center justify-center rounded-lg border bg-orange-200 border-orange-300">
      <component :is="icons['BoltIcon']" class="w-6 h-6" />
    </div>
    <div class="flex flex-col gap-2 text-center">
      <span class="text-base font-normal">
        {{ t('slides_editor.components.add_spark_button.add_spark') }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { inject } from 'vue'
import * as icons from "@heroicons/vue/24/outline"
import { useSidePanelHelpers } from '@/features/slides_editor/composables/useSidePanelHelpers'
import { t } from '@/libs/i18n'

const { pushToStack } = useSidePanelHelpers()
const slide = inject('currentSlide')

const onAddSpark = async () => {
  const block = slide.value.blocks.find(block => block.block_type === 'section')

  block.has_spark = true
  
  pushToStack({
    content: {
      component: 'SparkForm',
      title: t('slides_editor.components.spark_preview.edit_spark'),
      props: {
        block: block
      }
    }
  })
}
</script>
